import React from 'react';

import './Modal.scss';

const Modal = ({ className, id, title, content, footer, style, modalSize, openCloseModal }) => {
  return (
    <div className={`modal fade show-modal ${className}`} style={style ? style.modalStyle : {}} id={id} role="dialog">
      <div className={`modal-dialog ${modalSize ? modalSize : 'modal-lg'}`} style={style ? style.modalDialog : {}}>
        <div className="modal-content" style={style ? style.alignModalStyle : {}}>
          <div className="modal-header">
            <div className="modal-title">{title}</div>
            <div data-dismiss="modal" onClick={openCloseModal}>
              {/* <button style={{ right: '-34px', borderRadius: '4px' }} className="mdl-cls-btn mdl-cls-btn2">✕</button> */}
              <button class="btn-close-rightbar" style={{ position: 'absolute', right: '16px', top: '13px' }}>
                <svg class="brand-path-color" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 9.99"><path id="Path_59483" data-name="Path 59483" d="M-440.148-160.721l3.3-3.3a1,1,0,0,0,0-1.407,1.019,1.019,0,0,0-1.408,0l-3.3,3.3-3.3-3.3a1.017,1.017,0,0,0-1.405,0,.986.986,0,0,0-.292.7.988.988,0,0,0,.292.7l3.3,3.3-3.3,3.3a.987.987,0,0,0-.292.7.988.988,0,0,0,.292.7,1,1,0,0,0,1.406,0l3.3-3.3,3.3,3.3a1,1,0,0,0,.7.291.992.992,0,0,0,.7-.291,1,1,0,0,0,0-1.407Z" transform="translate(446.554 165.712)" fill="#645cfc"></path></svg>
              </button>
            </div>
          </div>
          {content}
          {footer}
        </div>
      </div>
    </div>
  );
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js